import React, {useEffect, useState} from 'react';
import axios from "axios";
import {NavLink, useNavigate} from "react-router-dom";
import {Button, ButtonGroup} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit, faTrash} from "@fortawesome/free-solid-svg-icons";
import {Spinner} from "reactstrap";


const AdminGTB = () => {

    const [bonusHunts, setBonusHunts] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        axios.get(`https://bht.bet/api/dzWJjyef5PIbA1nMjQPW2KTTy1gfqUiw/hunts?limit=5`).then((response) => {
            const hunts = response.data;
            setBonusHunts(hunts);
            setLoading(false);
        });
    }, []);

    return (

        <div className="card text-bg-dark">
            <div className="card-header">GTB</div>
            <div className="card-body p-0">
                <table className="table table-dark table-striped">
                    <thead>
                    <tr>
                        <th>
                            #
                        </th>
                        <th>
                            Name
                        </th>
                        <th>
                            Bonuses
                        </th>
                        <th></th>
                    </tr>
                    </thead>
                    {loading ? (<Spinner/>) : (
                        <tbody>
                        {bonusHunts.length > 0 ? (
                            <>
                                {bonusHunts.map((row, index) => {
                                    return (<tr>
                                        <th scope="row">
                                            {row.id}
                                        </th>
                                        <td>
                                            {row.name}
                                        </td>
                                        <td>
                                            {row.bonus_count_opened} / {row.bonus_count_total}
                                        </td>
                                        <td style={{textAlign: 'right'}}>
                                            <ButtonGroup>
                                                <Button color="primary" onClick={() => navigate(`${row.id}`)}>
                                                    <FontAwesomeIcon icon={faEdit}/>
                                                </Button>
                                            </ButtonGroup>
                                        </td>
                                    </tr>);
                                })}
                            </>
                        ) : (<></>)}

                        </tbody>
                    )}
                </table>
            </div>
        </div>
    );

};

export default AdminGTB;